export const SET_TRIPS_PAGE = 'SET_TRIPS_PAGE'
export const SET_TRIPS_FILTER_MONTHS = 'SET_TRIPS_FILTER_MONTHS'
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_FILTER_INVOICE_NUMBER = 'SET_FILTER_INVOICE_NUMBER'
export const SET_FILTER_CHECKIN_MONTH = 'SET_FILTER_CHECKIN_MONTH'
export const SET_FILTER_CHECKIN_DATE_FROM = 'SET_FILTER_CHECKIN_DATE_FROM'
export const SET_FILTER_CHECKIN_DATE_TO = 'SET_FILTER_CHECKIN_DATE_TO'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_ORDER_DIRECTION = 'SET_ORDER_DIRECTION'

export default {
  SET_TRIPS_PAGE,
  SET_TRIPS_FILTER_MONTHS,
  SET_PAGE_NUMBER,
  SET_PAGE_SIZE,
  SET_FILTER_INVOICE_NUMBER,
  SET_FILTER_CHECKIN_MONTH,
  SET_FILTER_CHECKIN_DATE_FROM,
  SET_FILTER_CHECKIN_DATE_TO,
  SET_ORDER_BY,
  SET_ORDER_DIRECTION
}



// WEBPACK FOOTER //
// ./src/store/modules/trip/mutation-types.js